import axiosApiClient from '..';
import { handleError } from '../../utils/errors';

const BASE_URL = 'users';

class UserService {
  fetchInfo = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/me`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { opsUser } = response.data.data;

      return { opsUser };
    } catch (err) {
      throw handleError(err, "Error occurred while fetching user's info.");
    }
  };

  verifyEmail = async ({ code }) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/verify/code`, {
        code,
      });
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while verify email');
    }
  };
  getDeliveryUsers = async ({ page, search }) => {
    if (!search) {
      search = '';
    }
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/delivery-users/?page=${page}&search=${search}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const data = response.data;
      return { ...data, page };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching delivery users.');
    }
  };

  getPartnerUsers = async ({ page, search }) => {
    if (!search) {
      search = '';
    }
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/partner-users/?page=${page}&search=${search}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const data = response.data;
      return { ...data, page };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching partner users.');
    }
  };

  activatePartnerUser = async id => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/partner-user-activate/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      response.data.id = id;
      const data = response.data;

      return data;
    } catch (err) {
      throw handleError(err, 'Error occurred while activating partner user.');
    }
  };

  getPartnersItems = async ({ page, search }) => {
    if (!search) {
      search = '';
    }
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/partner-items/?page=${page}&search=${search}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const data = response.data;
      return { ...data, page };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching partner items.');
    }
  };

  fetchCategories = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/categories`);
      if (response.status !== 200) {
        throw new Error();
      }
      const data = response.data;
      return data;
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching categories.');
    }
  };

  fetchMarketplaceCategories = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/marketplaceCategories`);
      if (response.status !== 200) {
        throw new Error();
      }
      const data = response.data;
      return data;
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching marketplaceCategories.');
    }
  };

  fetchSections = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/sections`);
      if (response.status !== 200) {
        throw new Error();
      }
      const data = response.data;
      return data;
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching sections.');
    }
  };

  approveProduct = async ({ id, body }) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/partner-item-approve/${id}`, body);
      if (response.status !== 200) {
        throw new Error();
      }
      const data = response.data;
      return data;
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching sections.');
    }
  };

  getProductById = async ({ id }) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/partner-item/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const data = response.data;
      return data;
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching product.');
    }
  };
  editItem = async (requestData, id) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/partner-item-edit/${id}`, requestData);
      if (response.status !== 200) {
        throw new Error();
      }
      const data = response.data;

      return data;
    } catch (err) {
      throw handleError(err, 'Error occurred while editing item.');
    }
  };

  toggleItemAvailability = async id => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/partner-item-availability/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      response.data.id = id;
      const data = response.data;

      return data;
    } catch (err) {
      throw handleError(err, 'Error occurred while editing availability of item.');
    }
  };

  deleteItem = async id => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/partner-item-delete/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const data = response.data;
      return { data, id };
    } catch (err) {
      throw handleError(err, 'Error occurred while deleting item.');
    }
  };

  loginToPartnerUser = async id => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/login-partner-user/${id}`);
      if (response.status !== 201) {
        throw new Error();
      }
      const data = response.data;
      return data;
    } catch (err) {
      throw handleError(err, 'Error occurred while loging to partner user.');
    }
  };

  fetchOrders = async page => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/partner-orders?page=${page}`);
      if (response.status !== 200) {
        throw new Error();
      }
      response.data.page = page;
      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching orders.');
    }
  };

  fetchOrder = async id => {
    try {
      const response = await axiosApiClient.get(`/${BASE_URL}/partner-orders/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching order.');
    }
  };

  setOrderState = async (id, body) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/partner-orders/state/${id}`, body);
      if (response.status !== 200) {
        throw new Error();
      }
      response.data.id = id;
      const data = response.data;

      return data;
    } catch (err) {
      throw handleError(err, 'Error occurred while editing state of order.');
    }
  };
}
const userService = new UserService();

export default userService;
